import { GAME_PAD_SPIN_ACTIVE } from '../../stateManagment/gameState';

class SpinButtonHelper {
  get active() {
    return GAME_PAD_SPIN_ACTIVE.getValue();
  }

  disable() {
    GAME_PAD_SPIN_ACTIVE.next(false);
  }

  enable() {
    GAME_PAD_SPIN_ACTIVE.next(true);
  }

  subscribe(...args) {
    return GAME_PAD_SPIN_ACTIVE.subscribe(...args)
  }
}

export const spinButtonHelper = new SpinButtonHelper();
